import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  extractDataFromObject,
  handleLoginRedirect,
  handleLogoutRedirect,
  jsonApiHeader,
  showSuccessMessage,
  jsonApiHeaderBusinessName,
} from '.././../../../actions/utilAction';
import { API_URL } from '../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  extractDataFromObject,
  handleLoginRedirect,
  handleLogoutRedirect,
  jsonApiHeaderBusinessName,
};

//export const LOGIN_API = `${API_URL}/authentication/superAdminLogin`;
export const LOGIN_API = `${API_URL}/api/SuperAdmin/Login`;
export const FORGOT_PASSWORD_API = `${API_URL}/api/Organization/ForgotPassword`;
export const REFRESH_TOKEN = `${API_URL}/GetUserByToken`;
export const RESET_PASSWORD_API = `${API_URL}/api/Organization/ResetPassword`;
export const UPDATE_LOGIN_PASSWORD_API = `${API_URL}/api/Organization/UpdateExpiredPassword`;

export const loginActionTypes = {
  post_login: createRequestActionTypes('POST_LOGIN'),
  post_forgotPassword: createRequestActionTypes('POST_FOTGOT_PASSWORD'),
  logout_user: createRequestActionTypes('LOGOUT_USER'),
  refresh_token: createRequestActionTypes('REFRESH_TOKEN'),
  post_resetPassword: createRequestActionTypes('POST_RESET_PASSWORD'),
  update_loginUserPassword: createRequestActionTypes('UPDATE_LOGINUSERPASSWORD'),

};



// WEBPACK FOOTER //
// ./src/modules/Superadmin/logins/constants/ApiConstants.js